import { Injectable, inject } from '@angular/core';

import { fetchAndActivate, getRemoteConfig, getValue } from '@firebase/remote-config';
import { initializeApp } from 'firebase/app';

import { FIREBASE_CONFIG } from '../tokens/firebase.tokens';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private readonly firebaseConfig = inject(FIREBASE_CONFIG);
  private isInitialized = false;

  getRemoteConfig() {
    const firebaseApp = initializeApp(this.firebaseConfig);
    return getRemoteConfig(firebaseApp);
  }

  async initialize(): Promise<void> {
    if (!this.isInitialized) {
      const remoteConfig = this.getRemoteConfig();
      await fetchAndActivate(remoteConfig);
      this.isInitialized = true;
    }
  }

  isFeatureEnabled(flagName: string): boolean {
    return getValue(this.getRemoteConfig(), flagName).asBoolean();
  }

  async refreshFeatureFlags(): Promise<void> {
    const remoteConfig = this.getRemoteConfig();
    await fetchAndActivate(remoteConfig);
  }
}
